import { useLanguage } from '../useLanguage';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-dark-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4 text-primary-400">Flex CTO</h3>
            <p className="text-gray-300 mb-4 max-w-md leading-relaxed">
              {t.footer.description}
            </p>
            <div className="flex space-x-6">
              <a
                href="https://www.linkedin.com/in/benjamin-juarez-4826862a/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-all duration-200 hover:scale-105 flex items-center space-x-2"
              >
                <span className="font-bold">in</span>
                <span>{t.footer.linkedin}</span>
              </a>
              {/* <a
                href="https://ko-fi.com/C0C2QPCEG"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-all duration-200 hover:scale-105 flex items-center space-x-2"
              >
                <span>Support</span>
              </a> */}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-white">{t.footer.expertise}</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="hover:text-primary-400 transition-all duration-200 hover:translate-x-1 cursor-pointer">{t.footer.cloudArchitecture}</li>
              <li className="hover:text-primary-400 transition-all duration-200 hover:translate-x-1 cursor-pointer">{t.footer.aiIntegration}</li>
              <li className="hover:text-primary-400 transition-all duration-200 hover:translate-x-1 cursor-pointer">{t.footer.teamBuilding}</li>
              <li className="hover:text-primary-400 transition-all duration-200 hover:translate-x-1 cursor-pointer">{t.footer.techStrategy}</li>
              <li className="hover:text-primary-400 transition-all duration-200 hover:translate-x-1 cursor-pointer">{t.footer.performanceOptimization}</li>
              <li className="hover:text-primary-400 transition-all duration-200 hover:translate-x-1 cursor-pointer">{t.footer.securityCompliance}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-white">{t.footer.getStarted}</h4>
            <ul className="space-y-3 text-gray-300">
              <li>
                <a
                  href="https://calendly.com/benjamin-juarez/60min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary-400 transition-all duration-200 hover:translate-x-1 flex items-center space-x-2"
                >
                  <span>{t.footer.freeConsultation}</span>
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <span className="text-primary-400">•</span>
                <span>{t.footer.responseTime}</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="text-primary-400">•</span>
                <span>{t.footer.successRate}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} {t.footer.copyright}
              </p>
              <p className="text-gray-400 text-sm">
                {t.footer.builtWith}
              </p>
            </div>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-xs text-green-400">{t.footer.available}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;